import styled, { css } from 'styled-components'

interface CheckboxContainerProps {
  withBg: boolean;
  variation: 'medium' | 'small' | 'thin'
  checked: boolean;
  isIncorrect?: boolean;
}

interface CheckboxProps {
  checked: boolean;
  variation: 'medium' | 'small' | 'thin'
}

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  display: flex;
  align-items: center;
  gap: ${({ variation }) => variation === 'medium' ? '16px' : '8px'};
  cursor: pointer;
  width: ${({ withBg }) => withBg ? '100%' : 'fit-content'};
  padding: ${({ withBg, variation }) => !withBg ? '0' : variation === 'medium' ? '28px 24px' : '16px 22px'};
  border: ${({ withBg, checked, isIncorrect }) => !withBg ? 'none' : isIncorrect ? '2px solid #E84242' : checked ? '4px solid #3D6666' : '1px solid #C8C8C8'};
  background-color: ${({ withBg, checked }) => !withBg ? 'inherit' : checked ? '#EBF2F2' : '#FFF'};

  & input {
    display: none;
  }

  & span {
    font-weight: ${({ variation }) => variation === 'thin' ? 400 : 900};
    font-size: ${({ variation }) => variation === 'medium' ? '20px' : '16px'};
    line-height: ${({ variation }) => variation === 'medium' ? '27px' : '24px'};
    ${props => props.variation === 'thin' && css`
      color: #08193C;
    `}
  }
`

export const Checkbox = styled.div<CheckboxProps>`
  width: ${({ variation }) => variation === 'medium' ? '32px' : '24px'};
  height: ${({ variation }) => variation === 'medium' ? '32px' : '24px'};
  min-width: ${({ variation }) => variation === 'medium' ? '32px' : '24px'};
  min-height: ${({ variation }) => variation === 'medium' ? '32px' : '24px'};
  background-color: ${({ checked }) => checked ? '#3D6666' : '#FFF'};
  border: ${({ checked }) => checked ? 'none' : '2px solid #C8C8C8'};
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 100%;
    height: 100%;
    fill: #fff;
  }
`